import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  SectionTitle,
  Row,
  StyledColumn,
  Img,
  Description,
  Title,
  Name,
  TitleContainer,
  Color,
  Colors,
  Button,
  Titles,
  FooterValues,
  TitleRow,
  StyledSectionTitle,
  Size,
  SizeValue,
  Green,
  ChooseFile,
  ErrorDiv,
  Success,
  SubTitle,
  LoaderDiv,
  ImageContainer,
  HorizontalLine,
  VerticalLine,
  PrintLogo,
  RemoveLogo,
  LogoContainer,
  RotateLogo,
  ResizeLogo,
  Background,
  PrintAreTextContainer,
  PrintAreaText,
  PrintAreaBorder,
  PrintAreaContainer,
  PrintLogoInvisible,
  PhotoBorder,
  PopupTitle,
  PopupContainer,
  PopupText,
  Triangle,
  PopupTitleContainer,
  XIcon,
  ButtonsContainer,
  Relative,
  TextColumn,
  Label,
  Line,
  ItemInfoContainer,
  Price,
  Icon,
  QuantityContainer,
  Minus,
  Plus,
  Quantity,
  PhotosColumn,
  SuggestedItemsContainer,
  SuggestItem,
  SuggestItemPhoto,
  SuggestItemName,
  SuggestItemPrice,
  ImageColumn,
  ChevronContainer,
  ChevronTop,
  ChevronDown,
  Buttons,
  StyledButtons,
  SuggestedRow,
  ChevronContainerSuggest,
  ChevronLeft,
  ChevronRight,
  SuggestRelative,
  LeftButton,
  ImageRelative,
  StyledImg,
  OldColumn,
  Dots,
  Dot,
  MainContainer,
  HeaderWrapper,
  Content,
  UploadButton,
} from "./MarketplaceItemDetailPage.styles";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getMarketplaceItemById } from "../../../../store/slices/marketplace/asyncThunks";
import { selectBusinessUserInfo } from "../../../../store/slices/businessUser/slice";
import {
  convertBase64,
  priceFormatter,
  priceFormatterNumber,
} from "../../../../utils/utils";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Footer from "../../../../components/Footer.js";
import {
  addToCart,
  cartItemsData,
  editCartItem,
  resetEditItemData,
  selectEditItemData,
  selectedMarketplaceItem,
  selectedMarketplaceItemLoader,
  selectedSuggestedItems,
  setEditItemData,
} from "../../../../store/slices/marketplace/marketplaceSlice";
import { toast } from "react-toastify";
import { getCurrencySymbol } from "../../../../utils/constants";
import MiniLoader from "../../../../components/MiniLoader/MiniLoader";
import PriceBreakModal from "../../../../components/Modal/PriceBreakModal.js";
import InstantQuoteModal from "../../../../components/Modal/InstantQuoteModal.js";
import LoginModal from "../../../../components/Modal/LoginModal.js";
import BuySampleModal from "../../../../components/Modal/BuySampleModal.js";
import CartModal from "../../../../components/Modal/CartModal.js";
import FailedImg from "../../../../assets/images/failed.png";
import openToast from "../../../../utils/toast.js";
import { selectedLocale } from "../../../../store/slices/common/slice.js";
import { ReactComponent as RemoveIcon } from "../../../../assets/icons/removeLogo.svg";
import { ReactComponent as RotateIcon } from "../../../../assets/icons/rotateLogo.svg";
import { ReactComponent as ResizeIcon } from "../../../../assets/icons/resizeLogo.svg";
import { ReactComponent as Trash } from "../../../../assets/icons/remove.svg";
import Draggable from "react-draggable";
import { generatePhotosWithLogo } from "../../../../store/slices/photoProcessing/asyncThunks.js";
import KeepInMindModal from "../../../../components/Modal/KeepInMindModal.js";
import GalleryModal from "../../../../components/Modal/GalleryModal.js";
import Header from "../../../../components/NewHeader/NewHeader";
import SearchComponent from "../../../LandingPage/SearchComponent.js";
import QuantityModal from "../../../../components/Modal/QuantityModal.js";

const MarketplaceItemDetailPage = () => {
  const { itemId } = useParams();
  const location = useLocation();
  const { state } = location;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loggedIn, id } = useSelector(selectBusinessUserInfo);
  const item = useSelector(selectedMarketplaceItem);
  const suggestedItems = useSelector(selectedSuggestedItems);
  const loading = useSelector(selectedMarketplaceItemLoader);
  const [activeIndex, setActiveIndex] = useState(0);
  const fileInputRef = useRef(null);
  const editItemData = useSelector(selectEditItemData);

  const [priceBreaksModal, setPriceBreaksModal] = useState(false);
  const [instantQuoteModal, setInstantQuoteModal] = useState(false);
  const [buySampleModal, setBuySampleModal] = useState(false);
  const [loginModal, setLoginModal] = useState(false);
  const [quantityModal, setQuantityModal] = useState(false);

  const [cartModal, setCartModal] = useState(false);

  const [quantityValue, setQuantityValue] = useState(1);
  const [activeColor, setActiveColor] = useState({});
  const [activeSize, setActiveSize] = useState({});
  const [activeCard, setActiveCard] = useState({});
  const [logo, setLogo] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);
  const [logoName, setLogoName] = useState(null);
  const [quantityBlank, setQuantityBlank] = useState(0);
  const [quantityBranded, setQuantityBranded] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [errorBlank, setErrorBlank] = useState(false);
  const [errorBranded, setErrorBranded] = useState(false);
  const toastId = useRef(null);
  const [openGallery, setOpenGallery] = useState(false);
  const [loadingItemId, setLoadingItemId] = useState(null);
  const [quantityModalContext, setQuantityModalContext] = useState(null);
  const [modalSubtitle, setModalSubtitle] = useState("");

  const cartItems = useSelector(cartItemsData);

  useEffect(() => {
    if (editItemData?.id) {
      resetEditItemData();
    }
    if (state) {
      dispatch(setEditItemData({ product: state.product, index: state.index }));
    }
    dispatch(getMarketplaceItemById(itemId));
  }, [dispatch, editItemData?.id, itemId, state]);

  useEffect(() => {
    setLogo(null);
    setLogoName(null);
  }, [item]);

  useEffect(() => {
    if (item) {
      setIsLoading(false);

      if (item.subcategories && Object.values(item.subcategories).length > 0) {
        Object.values(item.subcategories)?.map((color) => {
          const colors = color.filter(
            (array) => array.subcategoryName === "color",
          );
          let newColor = colors[0];

          if (colors && colors.length > 0) {
            setActiveColor({ id: newColor.valueId, name: newColor.value });
            if (item.photos) {
              const filteredImages = item.photos.filter(
                (el) =>
                  el.marketplaceSubcategoryItemId == null ||
                  el.marketplaceSubcategoryItemId === activeColor.id,
              );
              setPhotos(filteredImages);
            }
          }
        });
      }
    }
  }, [item]);

  const [photos, setPhotos] = useState([]);

  useEffect(() => {
    if (item.photos) {
      const filteredImages = item.photos.filter(
        (el) =>
          el.marketplaceSubcategoryItemId == null ||
          el.marketplaceSubcategoryItemId === activeColor.id,
      );
      setPhotos(filteredImages);
    }
  }, [item.photos, activeColor]);

  useEffect(() => {
    let targetPath;

    if (location.pathname.includes("/ops-portal")) {
      targetPath = `/ops-portal/marketplace/item-detail/${itemId}`;
    } else if (loggedIn) {
      targetPath = `/admin-portal/marketplace/item-detail/${itemId}`;
    } else {
      targetPath = `/marketplace/${itemId}`;
    }

    if (location.pathname !== targetPath) {
      navigate(targetPath, { replace: true });
    }
  }, [loggedIn, itemId, location.pathname]);

  useEffect(() => {
    if (editItemData && editItemData?.quantity) {
      setQuantityValue(editItemData?.quantity);
    } else if (item && item.minQuantity) {
      setQuantityValue(item.minQuantity);
    }
  }, [editItemData, item]);

  useEffect(() => {
    if (editItemData && editItemData?.color?.id) {
      setActiveColor(editItemData.color);
    }
    if (editItemData && editItemData?.size?.id) {
      setActiveSize(editItemData.size);
    }
    if (editItemData && editItemData?.giftCard?.id) {
      setActiveCard(editItemData.giftCard);
    }
  }, [editItemData]);

  const subcategoriesContainPrice = Object.values(item.subcategories).some(
    (obj) =>
      Object.values(obj).some(
        (innerObj) =>
          innerObj.subcategoryName === "price" ||
          innerObj.subcategoryName === "Gift Card Value",
      ),
  );

  useEffect(() => {
    if (!editItemData?.giftCard) {
      if (item && item?.productId) {
        const subcategoriesValues = Object.values(item.subcategories);

        if (
          Array.isArray(subcategoriesValues) &&
          subcategoriesValues.length > 0 &&
          subcategoriesContainPrice
        ) {
          const firstSubcategoryArray = subcategoriesValues[0];

          if (
            Array.isArray(firstSubcategoryArray) &&
            firstSubcategoryArray.length > 0
          ) {
            const firstSubcategory = firstSubcategoryArray[0];

            if (
              firstSubcategory &&
              firstSubcategory.valueId &&
              firstSubcategory.value &&
              firstSubcategory.price
            ) {
              const newActiveCard = {
                id: firstSubcategory.valueId,
                name: firstSubcategory.value,
                price: firstSubcategory.price,
              };

              setActiveCard(newActiveCard);
            }
          }
        }
      }
    }
  }, [editItemData, item, subcategoriesContainPrice]);

  const subcategoriesContainColor = Object.values(item.subcategories).some(
    (obj) =>
      Object.values(obj).some(
        (innerObj) => innerObj.subcategoryName === "color",
      ),
  );

  const subcategoriesContainSize = Object.values(item.subcategories).some(
    (obj) =>
      Object.values(obj).some(
        (innerObj) => innerObj.subcategoryName === "size",
      ),
  );

  const truncateText = (text, maxLength) => {
    if (text && text.length <= maxLength) {
      return text;
    } else {
      return text?.substring(0, maxLength) + "...";
    }
  };

  const convertLogo = async (selectedFile) => {
    const base64 = await convertBase64(selectedFile);
    setLogoUrl(base64);
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (item.designWithoutColor) {
        setShowKeepInMindModal(true);
      }

      setLogo(selectedFile);
      convertLogo(selectedFile);

      setLogoName(selectedFile.name);
    } else {
      setLogo(null);
      openToast(
        toastId,
        "marketplace-receipt-file",
        "error",
        t("Please select a logo file"),
      );
    }
  };

  const handlePriceBreaksClick = () => {
    setPriceBreaksModal(true);
  };

  const handlePickSize = (c) => {
    setActiveSize({ id: c.valueId, name: c.value });
  };

  const validate = (buyBlank, buyPrinted) => {
    let isValid = true;

    if (subcategoriesContainColor) {
      if (!activeColor?.id) {
        openToast(toastId, "add-to-cart", "error", t("please-select-a-color"));
        isValid = false;
        return;
      }
    }

    if (subcategoriesContainSize) {
      if (!activeSize?.id) {
        openToast(toastId, "add-to-cart", "error", t("please-select-a-size"));
        isValid = false;
        return;
      }
    }

    if (quantityValue < item.minQuantity) {
      openToast(
        toastId,
        "add-to-cart",
        "error",
        `${t("quantity-must-be-minimum")} ${item.minQuantity}`,
      );
      isValid = false;
      return;
    }
    if (item.availableQuantity !== null) {
      if (item.availableQuantity === 0) {
        setModalSubtitle("out-of-stock");
        setQuantityModal(true);
        isValid = false;
        return;
      }
      if (item.availableQuantity < quantityValue) {
        setQuantityModal(true);
        isValid = false;
        return;
      }

      const existingItem = cartItems.find(
        (cartItem) =>
          cartItem.id === item.id &&
          cartItem.name === item.name &&
          cartItem.photo.id === photos[0]?.id &&
          cartItem.color.id === activeColor?.id &&
          cartItem.size.id === activeSize?.id &&
          cartItem.giftCard.id === activeCard?.id &&
          cartItem.uploadLogoUrl === logoUrl &&
          cartItem.minQuantity === item.minQuantity &&
          cartItem.productionTime === item.productionTime &&
          cartItem.currency === item.currency &&
          !cartItem.photosWithLogo,
      );
      if (
        existingItem &&
        item.availableQuantity < existingItem.quantity + quantityValue
      ) {
        if (buyBlank) {
          setQuantityModalContext("blank");
        }
        if (buyPrinted) {
          setQuantityModalContext("printed");
        }
        isValid = false;
        setQuantityModal(true);
        setModalSubtitle("item-in-cart");
        return;
      }
    }

    return isValid;
  };

  const onQuantityModalYes = () => {
    if (buySampleModal && quantityModalContext) {
      if (quantityModalContext === "blank") {
        setQuantityBlank(item.availableQuantity);
      }
      if (quantityModalContext === "printed") {
        setQuantityBranded(item.availableQuantity);
      }
    } else {
      setQuantityValue(item.availableQuantity);
    }
    setQuantityModalContext(null);
    setQuantityModal(false);
  };

  const totalItemPrice = useMemo(() => {
    if (item && item.priceBreaks) {
      if (quantityValue) {
        let minQuantityPriceBreak = 0;
        let discount = 0;
        for (const priceBreak of item.priceBreaks) {
          if (
            quantityValue >= priceBreak.minQuantity &&
            priceBreak.minQuantity > minQuantityPriceBreak
          ) {
            minQuantityPriceBreak = priceBreak.minQuantity;
            discount = priceBreak.discount;
          }
        }
        const priceWithVat = priceFormatter(item.price, true, 15);
        return (
          (+priceWithVat - (+priceWithVat * discount) / 100) * +quantityValue
        );
      }
      return priceFormatter(item.price, true, 15);
    }
    return priceFormatter(item.price, true, 15);
  }, [item, quantityValue]);

  const createCartItemObject = (cartItemId) => {
    return {
      id: item.id,
      name: item.name,
      photo: photos[0],
      color: {
        id: activeColor?.id,
        name: activeColor?.name,
      },
      size: {
        id: activeSize?.id,
        name: activeSize?.name,
      },
      giftCard: {
        id: activeCard?.id,
        name: activeCard?.name,
        price: activeCard?.price,
      },
      uploadLogoUrl: logoUrl,
      uploadLogoName: logoName,
      priceBreaks: item.priceBreaks,
      samplePrice: item.samplePrice,
      printedPrice: item.printedPrice,
      itemPrice: item.price,
      minQuantity: item.minQuantity,
      quantity: +quantityValue,
      productionTime: item.productionTime,
      totalPrice: totalItemPrice,
      buyBlank: false,
      buyPrinted: false,
      currency: item.currency,
      favorite: item.favorite,
      productId: item.productId,
      cartItemId,
      businessUserId: id,
    };
  };

  const locale = useSelector(selectedLocale);

  const ar = locale === "ar";

  const [hover, setHover] = useState(false);
  const [rotateAngle, setRotateAngle] = useState(0);
  const [drag, setDrag] = useState(false);
  const [isFirstDrag, setFirstDrag] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showKeepInMindModal, setShowKeepInMindModal] = useState(false);

  const [loadingLogo, setLoadingLogo] = useState(true);
  const [loadingImage, setLoadingImage] = useState(true);

  const [scaleImage, setScaleImage] = useState({ x: 1, y: 1 });
  const [invertedScaleImage, setInvertedScaleImage] = useState({ x: 1, y: 1 });

  const [printingAreaSize, setPrintingAreaSize] = useState({
    width: 170,
    height: 200,
    top: "50%",
    left: "50%",
  });

  const [printingAreaSizes, setPrintingAreaSizes] = useState([]);

  const imageRef = useRef(null);
  const divRef = useRef(null);
  const imgRef = useRef(null);
  const itemPhotoRef = useRef(null);

  const [sizes, setSize] = useState({
    width: printingAreaSize.width,
    height: "auto",
  });

  const [photosLogoPosition, setPhotosLogoPosition] = useState([]);

  const [counter, setCounter] = useState(1);

  const handlePickColor = (c) => {
    setActiveColor({ id: c.valueId, name: c.value });
    setActiveIndex(0);
  };

  useEffect(() => {
    let areas = [];
    let photosData = [];
    if (item && item.uploadDesign) {
      for (const [index, photo] of photos.entries()) {
        let printArea = photo.itemLogoPrintAreas[0];

        if (printArea) {
          printArea = {
            top: printArea.top,
            left: printArea.left,
            width: printArea.width,
            height: printArea.height,
          };
        }

        areas.push(
          photo.itemLogoPrintAreas.length
            ? { ...printArea, hasArea: true }
            : { hasArea: false },
        );

        photosData.push(
          photo.itemLogoPrintAreas.length
            ? {
                top: 0,
                left: 0,
                width: 150,
                height: "auto",
                rotateAngle: 0,
                hasLogo: true,
                isActive: index === activeIndex ? true : false,
              }
            : { hasLogo: false },
        );
      }
    }

    setPrintingAreaSizes(areas);
    setPhotosLogoPosition(photosData);
    setCounter((prev) => prev + 1);
  }, [item, logo, photos]);

  useEffect(() => {
    if (printingAreaSizes) {
      let tmpPrintAreas = [...printingAreaSizes];

      let printArea = tmpPrintAreas[activeIndex];
      if (printArea && printArea?.hasArea) {
        tmpPrintAreas[activeIndex] = {
          ...printArea,
          topScaled: printArea.top * invertedScaleImage.y,
          leftScaled: printArea.left * invertedScaleImage.x,
          widthScaled: printArea.width * invertedScaleImage.x,
          heightScaled: printArea.height * invertedScaleImage.y,
        };
        setPrintingAreaSizes(tmpPrintAreas);
      }
    }
  }, [activeIndex, logo, invertedScaleImage]);

  useEffect(() => {
    if (photosLogoPosition[activeIndex]?.rotateAngle) {
      setRotateAngle(photosLogoPosition[activeIndex].rotateAngle);
    }

    setDrag(false);
    setCounter((prev) => prev + 1);
  }, [activeIndex]);

  const onLoadPicture = () => {
    setLoadingImage(false);
    if (itemPhotoRef.current) {
      let scaleImage = { x: 1, y: 1 };
      let invertedScaleImage = { x: 1, y: 1 };
      scaleImage.x =
        itemPhotoRef.current?.naturalWidth / itemPhotoRef.current?.width;
      scaleImage.y =
        itemPhotoRef.current?.naturalHeight / itemPhotoRef.current?.height;

      invertedScaleImage.x =
        itemPhotoRef.current?.width / itemPhotoRef.current?.naturalWidth;
      invertedScaleImage.y =
        itemPhotoRef.current?.height / itemPhotoRef.current?.naturalHeight;

      setScaleImage(scaleImage);
      setInvertedScaleImage(invertedScaleImage);
    }
  };

  const onLoadLogo = (ev) => {
    if (photosLogoPosition[activeIndex].height === "auto") {
      setPhotosLogoPosition((prev) => {
        prev[activeIndex].height = (150 * ev.target.height) / ev.target.width;
        return prev;
      });
    }
    setTimeout(() => {
      setLoadingLogo(false);
    }, 100);
  };

  const handleRotate = (event) => {
    event.stopPropagation();
    if (!event.clientX && event.touches) {
      event = event.touches[0];
    }

    const target = divRef.current;
    const rect = target.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    const startAngle =
      Math.atan2(event.clientY - centerY, event.clientX - centerX) *
      (180 / Math.PI);

    const handleMove = (moveEvent) => {
      if (!moveEvent.clientX && moveEvent.touches) {
        moveEvent = moveEvent.touches[0];
      }
      const currentAngle =
        Math.atan2(moveEvent.clientY - centerY, moveEvent.clientX - centerX) *
        (180 / Math.PI);

      const rotate = currentAngle - startAngle + rotateAngle;
      setPhotosLogoPosition((prev) => {
        prev[activeIndex].rotateAngle = rotate;
        return [...prev];
      });
      setRotateAngle(rotate);
    };

    const handleEnd = () => {
      document.removeEventListener("mousemove", handleMove);
      document.removeEventListener("mouseup", handleEnd);
      document.removeEventListener("touchmove", handleMove);
      document.removeEventListener("touchend", handleEnd);
    };

    document.addEventListener("mousemove", handleMove);
    document.addEventListener("mouseup", handleEnd);
    document.addEventListener("touchmove", handleMove);
    document.addEventListener("touchend", handleEnd);
  };

  const handleResize = (event) => {
    event.stopPropagation();

    if (!event.clientX && event.touches) {
      event = event.touches[0];
    }

    let tempSize = {
      width: photosLogoPosition[activeIndex].width,
      height: photosLogoPosition[activeIndex].height,
    };
    if (photosLogoPosition[activeIndex].height === "auto") {
      tempSize.height = imgRef.current.height;
    }

    const startPoint = { x: event.clientX, y: event.clientY };
    const startDimensions = tempSize;

    const handleMove = (moveEvent) => {
      if (!moveEvent.clientX && moveEvent.touches) {
        moveEvent = moveEvent.touches[0];
      }

      let dx = moveEvent.clientX - startPoint.x;

      let moveDirection = 3;
      if (
        photosLogoPosition[activeIndex]?.rotateAngle < -90 &&
        photosLogoPosition[activeIndex]?.rotateAngle > -270
      ) {
        moveDirection = -3;
      }

      dx = dx * moveDirection;

      const scale = (startDimensions.width + dx) / startDimensions.width;

      setSize({
        width: startDimensions.width + dx,
        height: startDimensions.height * scale,
      });
      setPhotosLogoPosition((prev) => {
        prev[activeIndex].width = startDimensions.width + dx;
        prev[activeIndex].height = startDimensions.height * scale;

        return prev;
      });
    };

    const handleEnd = () => {
      document.removeEventListener("mousemove", handleMove);
      document.removeEventListener("mouseup", handleEnd);
      document.removeEventListener("touchmove", handleMove);
      document.removeEventListener("touchend", handleEnd);
    };

    document.addEventListener("touchmove", handleMove);
    document.addEventListener("touchend", handleEnd);

    document.addEventListener("mousemove", handleMove);
    document.addEventListener("mouseup", handleEnd);
  };
  const addToCartAndCreatePhotosWithLogo = () => {
    let photosData = [];
    const cartItemId =
      Date.now().toString(36) + Math.random().toString(36).substr(2);
    if (logo) {
      for (let i = 0; i < printingAreaSizes.length; i++) {
        if (
          printingAreaSizes[i]?.hasArea &&
          photosLogoPosition[i]?.hasLogo &&
          photosLogoPosition[i]?.isActive
        ) {
          photosData.push({
            photoUrl: photos[i]?.url,
            positionY:
              (photosLogoPosition[i].top + printingAreaSizes[i].topScaled) *
              scaleImage.y,
            positionX:
              (photosLogoPosition[i].left + printingAreaSizes[i].leftScaled) *
              scaleImage.x,
            width: photosLogoPosition[i].width * scaleImage.x,
            height: photosLogoPosition[i].height * scaleImage.y,
            rotateAngle: photosLogoPosition[i].rotateAngle,
            indexPhoto: i,
          });
        }
      }
    }

    dispatch(addToCart(createCartItemObject(cartItemId)));

    setLoadingItemId(cartItemId);
    if (photosData.length !== 0 && logo) {
      dispatch(
        generatePhotosWithLogo({
          photosData,
          logo: logo,
          cartItemId: cartItemId,
        }),
      )
        .unwrap()
        .then((data) => {})
        .catch((error) => {
          openToast(
            toastId,
            "create-company-gifting-order",
            "error",
            t(error.message),
          );
        });
    }
    if (location.pathname.includes("ops-portal")) {
      toast.success(t("item-added-to-ops-order-successfully"));
      navigate("/ops-portal-create-order", {
        state: { openDetails: true, cartItemId },
      });
    } else {
      toast.success(t("item-added-to-cart-successfully"));
      setCartModal(true);
    }
  };

  const handleFirstDrag = () => {
    if (!isFirstDrag) {
      setFirstDrag(true);
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
      }, 5000);
    }
  };
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let timer;
    if (showPopup) {
      setIsVisible(true);
    } else {
      timer = setTimeout(() => setIsVisible(false), 250);
    }

    return () => clearTimeout(timer);
  }, [showPopup]);

  const handleRemoveLogoFromPhoto = (event) => {
    event.stopPropagation();

    setPhotosLogoPosition((prev) => {
      prev[activeIndex].hasLogo = false;
      prev[activeIndex].isActive = false;
      return [...prev];
    });
  };

  const onPlusClick = () => {
    setQuantityValue(quantityValue + 1);
  };

  const onMinusClick = () => {
    if (quantityValue === item.minQuantity) {
      setQuantityValue(item.minQuantity);
    } else {
      setQuantityValue(quantityValue - 1);
    }
  };

  useEffect(() => {
    if (quantityValue <= item.minQuantity) {
      setQuantityValue(item.minQuantity);
    } else if (quantityValue > 10000) {
      setQuantityValue(10000);
    }
  }, [quantityValue, item]);

  const [currentIndex, setCurrentIndex] = useState(0);
  const groupSize = 4;

  const visiblePhotos = photos.slice(currentIndex, currentIndex + groupSize);

  const handleNext = () => {
    if (currentIndex + groupSize < photos.length) {
      setCurrentIndex(currentIndex + groupSize);
    }
  };

  const handlePrevious = () => {
    if (currentIndex - groupSize >= 0) {
      setCurrentIndex(currentIndex - groupSize);
    }
  };

  const [suggestIndex, setSuggestIndex] = useState(0);
  const [suggestGroupSize, setSuggestGroupSize] = useState(4);

  useEffect(() => {
    const updateGroupSize = () => {
      if (window.innerWidth < 600) {
        setSuggestGroupSize(1);
      } else if (window.innerWidth <= 1315) {
        setSuggestGroupSize(2);
      } else {
        setSuggestGroupSize(4);
      }
    };

    window.addEventListener("resize", updateGroupSize);
    updateGroupSize();

    return () => {
      window.removeEventListener("resize", updateGroupSize);
    };
  }, []);

  const handleNextSuggest = () => {
    if (suggestIndex + suggestGroupSize < suggestedItems.length) {
      setSuggestIndex(suggestIndex + suggestGroupSize);
    }
  };

  const handlePreviousSuggest = () => {
    if (suggestIndex > 0) {
      setSuggestIndex(suggestIndex - suggestGroupSize);
    }
  };

  const visibleSuggestItems = suggestedItems.slice(
    suggestIndex,
    suggestIndex + suggestGroupSize,
  );

  const handleChangePhotoIndex = (index) => {
    setLoadingImage(true);
    setLoadingLogo(true);
    setActiveIndex(index);
    setPhotosLogoPosition((prev) => {
      if (prev[index]?.hasLogo) {
        prev[index].isActive = true;
      }
      return prev;
    });
  };

  const [headerVisible, setHeaderVisible] = useState(true);
  const [lastScrollUpY, setLastScrollUpY] = useState(0);
  const [scrollDirection, setScrollDirection] = useState(null);
  const lastScrollTopRef = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop = window.scrollY;
      const lastScrollTop = lastScrollTopRef.current;

      if (currentScrollTop === 0) {
        setHeaderVisible(true);
        setLastScrollUpY(currentScrollTop);
        setScrollDirection(null);
        lastScrollTopRef.current = currentScrollTop;
        return;
      }

      if (currentScrollTop > lastScrollTop) {
        setScrollDirection("down");
        setLastScrollUpY(currentScrollTop);
      } else {
        setScrollDirection("up");
      }

      if (scrollDirection === "up" && currentScrollTop < lastScrollUpY - 350) {
        setHeaderVisible(true);
        setLastScrollUpY(currentScrollTop);
      }

      if (
        scrollDirection === "down" &&
        currentScrollTop > lastScrollUpY + 350
      ) {
        setHeaderVisible(false);
      }

      lastScrollTopRef.current = currentScrollTop;
    };

    const handleScrollDebounced = () => {
      requestAnimationFrame(handleScroll);
    };

    window.addEventListener("scroll", handleScrollDebounced);

    return () => {
      window.removeEventListener("scroll", handleScrollDebounced);
    };
  }, [scrollDirection]);

  return (
    <>
      <MainContainer $column>
        <HeaderWrapper
          style={{
            opacity: headerVisible ? 1 : 0,
            marginTop: headerVisible ? 0 : -150,
            transition: "all 0.3s ease-in-out",
          }}
        >
          <Header />
        </HeaderWrapper>
        <Content>
          {!loading && !isLoading ? (
            item.id ? (
              <>
                <SearchComponent />
                <TitleRow>
                  {item?.category &&
                    item?.category?.map((c) => (
                      <StyledSectionTitle
                        key={c.id}
                        onClick={() => {
                          const query = {
                            category: c.marketplaceCategory.id,
                          };
                          const queryString = new URLSearchParams(
                            query,
                          ).toString();
                          const url = !loggedIn
                            ? `/marketplace?${queryString}`
                            : `/admin-portal/marketplace?${queryString}`;

                          const redirectUrl =
                            location.pathname ===
                            `/ops-portal/marketplace/item-detail/${itemId}`
                              ? `/ops-portal/marketplace?${queryString}`
                              : url;

                          navigate(redirectUrl);
                        }}
                      >
                        {c.marketplaceCategory?.name}
                      </StyledSectionTitle>
                    ))}
                  <SectionTitle> {"|"} </SectionTitle>
                  <StyledSectionTitle $noClick>
                    {ar && item?.nameAr ? item?.nameAr : item?.name}
                  </StyledSectionTitle>
                </TitleRow>
                <Row>
                  <ImageColumn>
                    <ImageRelative>
                      {currentIndex + groupSize < photos.length && (
                        <ChevronContainer onClick={handleNext}>
                          <ChevronDown />
                        </ChevronContainer>
                      )}

                      {currentIndex > 0 && (
                        <ChevronContainer onClick={handlePrevious} $top>
                          <ChevronTop />
                        </ChevronContainer>
                      )}
                      <PhotosColumn>
                        {visiblePhotos.map((photo, index) => (
                          <StyledImg
                            key={index}
                            onClick={() => {
                              if (index + currentIndex !== activeIndex) {
                                handleChangePhotoIndex(index + currentIndex);
                              }
                            }}
                            $small
                            $contain={!!item.productId}
                            src={photo?.url}
                            onLoad={onLoadPicture}
                          />
                        ))}
                      </PhotosColumn>
                    </ImageRelative>

                    <Buttons>
                      {item?.priceBreaks?.length !== 0 && (
                        <LeftButton onClick={handlePriceBreaksClick}>
                          {t("price-breaks")}
                        </LeftButton>
                      )}
                      <LeftButton
                        onClick={() => {
                          if (!loggedIn) {
                            setLoginModal(true);
                          } else if (validate()) {
                            setInstantQuoteModal(true);
                          }
                        }}
                      >
                        {t("instant-quote")}
                      </LeftButton>
                    </Buttons>
                  </ImageColumn>

                  <OldColumn>
                    {isVisible && (
                      <PopupContainer $show={showPopup}>
                        <Triangle />
                        <PopupTitleContainer>
                          <PopupTitle>{t("dont-worry")}</PopupTitle>
                          <XIcon onClick={() => setShowPopup(false)} />
                        </PopupTitleContainer>
                        <PopupText>{t("reviewed-human")}</PopupText>
                      </PopupContainer>
                    )}

                    <ImageContainer
                      ref={imageRef}
                      onClick={() => {
                        // setOpenGallery(true);
                      }}
                    >
                      {(logo || editItemData?.uploadLogoName) &&
                        printingAreaSizes[activeIndex]?.hasArea &&
                        photosLogoPosition[activeIndex]?.hasLogo &&
                        photosLogoPosition[activeIndex]?.isActive && (
                          <>
                            {drag ? (
                              <PrintAreaBorder
                                $drag
                                style={{
                                  width: `${printingAreaSizes[activeIndex].widthScaled}px`,
                                  height: `${printingAreaSizes[activeIndex].heightScaled}px`,
                                  top: `${printingAreaSizes[activeIndex].topScaled}px`,
                                  left: `${printingAreaSizes[activeIndex].leftScaled}px`,
                                }}
                              >
                                <VerticalLine $drag />
                                <HorizontalLine $drag />
                              </PrintAreaBorder>
                            ) : (
                              <PrintAreaBorder
                                $hover={hover}
                                style={{
                                  width: `${printingAreaSizes[activeIndex].widthScaled}px`,
                                  height: `${printingAreaSizes[activeIndex].heightScaled}px`,
                                  top: `${printingAreaSizes[activeIndex].topScaled}px`,
                                  left: `${printingAreaSizes[activeIndex].leftScaled}px`,
                                }}
                              >
                                <VerticalLine $hover={hover} />
                                <HorizontalLine $hover={hover} />
                              </PrintAreaBorder>
                            )}

                            <PrintAreaContainer
                              onMouseEnter={() => setHover(true)}
                              onMouseLeave={() => setHover(false)}
                              style={{
                                zIndex: 20,
                                width: `${printingAreaSizes[activeIndex].widthScaled}px`,
                                height: `${printingAreaSizes[activeIndex].heightScaled}px`,
                                top: `${printingAreaSizes[activeIndex].topScaled}px`,
                                left: `${printingAreaSizes[activeIndex].leftScaled}px`,
                              }}
                            >
                              {drag && <Background />}
                              {drag && (
                                <PrintAreTextContainer>
                                  <PrintAreaText>
                                    {t("print-area")}
                                  </PrintAreaText>
                                </PrintAreTextContainer>
                              )}
                              <Draggable
                                key={counter}
                                position={{
                                  x: photosLogoPosition[activeIndex].left,
                                  y: photosLogoPosition[activeIndex].top,
                                }}
                                onDrag={(e, data) => {
                                  setPhotosLogoPosition((prev) => {
                                    prev[activeIndex].left = data.x;
                                    prev[activeIndex].top = data.y;

                                    return [...prev];
                                  });
                                }}
                                onStart={(e) => {
                                  const isIcon = e.target.closest(".toolIcon");
                                  if (!isIcon) {
                                    setDrag(true);
                                    handleFirstDrag();
                                  } else {
                                    return false;
                                  }
                                }}
                                onStop={() => setDrag(false)}
                                disabled={drag}
                              >
                                <LogoContainer ref={divRef}>
                                  <div
                                    style={{
                                      rotate: `${photosLogoPosition[activeIndex].rotateAngle}deg`,
                                      width:
                                        photosLogoPosition[activeIndex]
                                          ?.width || "100%",
                                      height:
                                        photosLogoPosition[activeIndex]
                                          ?.height || "100%",
                                    }}
                                  >
                                    <RemoveLogo
                                      className="toolIcon"
                                      $hover={hover}
                                      onClick={handleRemoveLogoFromPhoto}
                                    >
                                      <RemoveIcon />
                                    </RemoveLogo>
                                    <RotateLogo
                                      className="toolIcon"
                                      $hover={hover}
                                      onMouseDown={handleRotate}
                                      onTouchStart={handleRotate}
                                    >
                                      <RotateIcon />
                                    </RotateLogo>

                                    <ResizeLogo
                                      className="toolIcon"
                                      $hover={hover}
                                      onTouchStart={handleResize}
                                      onMouseDown={handleResize}
                                    >
                                      <ResizeIcon />
                                    </ResizeLogo>
                                    <PhotoBorder $hover={hover}>
                                      <PrintLogoInvisible
                                        src={logoUrl}
                                        onMouseEnter={() => setHover(true)}
                                        onMouseLeave={() => setHover(false)}
                                      />
                                    </PhotoBorder>
                                  </div>
                                </LogoContainer>
                              </Draggable>
                            </PrintAreaContainer>
                          </>
                        )}

                      {(logo || editItemData?.uploadLogoName) &&
                        printingAreaSizes[activeIndex]?.hasArea &&
                        photosLogoPosition[activeIndex]?.hasLogo &&
                        photosLogoPosition[activeIndex]?.isActive && (
                          <PrintAreaContainer
                            style={{
                              width: `${printingAreaSizes[activeIndex].widthScaled}px`,
                              height: `${printingAreaSizes[activeIndex].heightScaled}px`,
                              top: `${printingAreaSizes[activeIndex].topScaled}px`,
                              left: `${printingAreaSizes[activeIndex].leftScaled}px`,
                              overflow: "hidden",
                            }}
                            $hover={hover}
                            onMouseEnter={() => setHover(true)}
                            onMouseLeave={() => setHover(false)}
                          >
                            <LogoContainer>
                              <div
                                key={activeIndex + counter}
                                style={{
                                  width: `${photosLogoPosition[activeIndex].width}px`,
                                  height: `${photosLogoPosition[activeIndex].height}px`,
                                  transform: `translate(${photosLogoPosition[activeIndex]?.left}px, ${photosLogoPosition[activeIndex]?.top}px)`,
                                }}
                              >
                                <PrintLogo
                                  ref={imgRef}
                                  src={logoUrl}
                                  style={{
                                    rotate: `${photosLogoPosition[activeIndex].rotateAngle}deg`,
                                    display:
                                      loadingLogo || loadingImage ? "none" : "",
                                  }}
                                  onLoad={(ev) => {
                                    onLoadLogo(ev);
                                  }}
                                  onLoadStart={() => {
                                    setLoadingLogo(true);
                                  }}
                                />
                              </div>
                            </LogoContainer>
                          </PrintAreaContainer>
                        )}

                      <Img
                        $contain={!!item.productId}
                        src={photos[activeIndex]?.url}
                        imageRef={itemPhotoRef}
                        onLoad={onLoadPicture}
                      />
                    </ImageContainer>
                    <Dots>
                      {photos.map((dot, i) => (
                        <Dot
                          key={i}
                          $active={i === activeIndex}
                          onClick={() => handleChangePhotoIndex(i)}
                        />
                      ))}
                    </Dots>
                  </OldColumn>

                  <StyledColumn>
                    <ItemInfoContainer>
                      <Name>
                        {ar && item?.nameAr ? item?.nameAr : item?.name}
                      </Name>

                      <Price>
                        {priceFormatter(item.price, true, 15)}{" "}
                        {getCurrencySymbol(item?.currency)}
                      </Price>

                      <Description>
                        {ar && item?.descriptionAr
                          ? item?.descriptionAr
                          : item?.description}
                      </Description>
                    </ItemInfoContainer>
                    <Line />

                    <Titles>
                      <TitleContainer>
                        <Label>{t("quantity")}</Label>
                        <QuantityContainer>
                          <Minus onClick={onMinusClick}>-</Minus>
                          <Quantity
                            value={quantityValue}
                            min={item.minQuantity}
                            onChange={(e) => {
                              const inputValue = e.target.value;

                              if (/^[0-9]*$/.test(inputValue)) {
                                setQuantityValue(inputValue);
                              }
                            }}
                          />
                          <Plus onClick={onPlusClick}>+</Plus>
                        </QuantityContainer>
                      </TitleContainer>
                      {item.availableQuantity != null &&
                        item.availableQuantity >= 0 && (
                          <FooterValues>
                            {t("available")}: {item.availableQuantity}
                          </FooterValues>
                        )}

                      {subcategoriesContainColor && (
                        <TitleContainer>
                          <Label>{t("choose-your-colors")}</Label>
                          <Colors>
                            {Object.values(item.subcategories)?.map((color) =>
                              color
                                .filter(
                                  (array) => array.subcategoryName === "color",
                                )
                                ?.map((c) => (
                                  <Color
                                    onClick={() => handlePickColor(c)}
                                    key={c.valueId}
                                    style={{
                                      backgroundColor: c.value,
                                      border:
                                        c.value === "white"
                                          ? "3px solid #fff"
                                          : activeColor?.id === c.valueId
                                            ? "3px solid #fff"
                                            : null,
                                      transform:
                                        activeColor?.id === c.valueId
                                          ? "scale(1.2)"
                                          : "scale(1)",
                                      opacity:
                                        activeColor === "" ||
                                        activeColor?.id === c.valueId
                                          ? 1
                                          : 0.2,
                                      outline:
                                        activeColor?.id === c.valueId
                                          ? "2px solid #484888"
                                          : null,
                                    }}
                                  />
                                )),
                            )}
                          </Colors>
                        </TitleContainer>
                      )}
                      {subcategoriesContainSize && (
                        <TitleContainer>
                          <Label>{t("choose-your-size")}</Label>
                          <Colors>
                            {Object.values(item.subcategories)?.map((size) =>
                              size
                                .filter(
                                  (array) => array.subcategoryName === "size",
                                )
                                ?.map((item) => (
                                  <Size
                                    onClick={() => handlePickSize(item)}
                                    key={item.valueId}
                                    style={{
                                      border:
                                        item.value === "white"
                                          ? "1.5px solid #484888"
                                          : activeSize?.id === item.valueId
                                            ? "2px solid #fff"
                                            : null,
                                      transform:
                                        activeSize?.id === item.valueId
                                          ? "scale(1.2)"
                                          : "scale(1)",
                                      opacity:
                                        activeSize === ""
                                          ? 1
                                          : activeSize?.id === item.valueId
                                            ? 1
                                            : 0.2,
                                      outline:
                                        activeSize?.id === item.valueId
                                          ? "2px solid #484888"
                                          : null,
                                    }}
                                  >
                                    <SizeValue>{item.value}</SizeValue>
                                  </Size>
                                )),
                            )}
                          </Colors>
                        </TitleContainer>
                      )}

                      {item.uploadDesign && (
                        <TitleContainer>
                          <Label>{t("upload-your-designs")}</Label>
                          <TextColumn>
                            <Description $small>
                              {t("maximum-file-size")}
                            </Description>
                            <Description $small>
                              {(logo || editItemData?.uploadLogoName) &&
                                t("file-name")}{" "}
                              <Green>
                                {logo && logo.name
                                  ? truncateText(logo?.name, 32)
                                  : editItemData && editItemData?.uploadLogoName
                                    ? truncateText(
                                        editItemData.uploadLogoName,
                                        32,
                                      )
                                    : null}
                              </Green>
                            </Description>
                          </TextColumn>
                          {logo || editItemData.uploadLogoName ? (
                            <ButtonsContainer>
                              <Relative>
                                <UploadButton>{t("upload-logo")}</UploadButton>
                                <ChooseFile
                                  type="file"
                                  ref={fileInputRef}
                                  accept="image/*"
                                  onChange={handleFileChange}
                                />
                              </Relative>
                              <Button
                                style={{
                                  backgroundColor: "#EA435D",
                                  maxWidth: 50,
                                }}
                                onClick={() => {
                                  setLogo(null);
                                  setLogoUrl(null);
                                  setLogoName(null);
                                }}
                              >
                                <Icon>
                                  <Trash fill="white" />
                                </Icon>
                              </Button>
                            </ButtonsContainer>
                          ) : (
                            <Relative>
                              <UploadButton>{t("upload-logo")}</UploadButton>
                              <ChooseFile
                                type="file"
                                ref={fileInputRef}
                                accept="image/*"
                                onChange={handleFileChange}
                              />
                            </Relative>
                          )}
                        </TitleContainer>
                      )}

                      <StyledButtons>
                        {item?.priceBreaks?.length !== 0 && (
                          <Button
                            onClick={handlePriceBreaksClick}
                            style={{ fontSize: 16 }}
                          >
                            {t("price-breaks")}
                          </Button>
                        )}
                        <Button
                          style={{ fontSize: 16 }}
                          onClick={() => {
                            if (!loggedIn) {
                              setLoginModal(true);
                            } else if (validate()) {
                              setInstantQuoteModal(true);
                            }
                          }}
                        >
                          {t("instant-quote")}
                        </Button>
                      </StyledButtons>

                      <Button
                        style={{ textTransform: "uppercase" }}
                        onClick={() => {
                          if (validate()) {
                            if (editItemData?.id) {
                              dispatch(
                                editCartItem({
                                  indexToRemove: editItemData.index,
                                  newItem: createCartItemObject(),
                                  businessUserId: id,
                                }),
                              );
                              toast.success(t("item-edited-successfully"));
                              if (loggedIn) {
                                navigate("/admin-portal/cart");
                              } else {
                                navigate("/cart");
                              }
                            } else {
                              addToCartAndCreatePhotosWithLogo();
                            }
                          }
                        }}
                      >
                        {!editItemData?.id
                          ? location.pathname.includes("ops-portal")
                            ? t("add-to-order")
                            : t("add-to-cart")
                          : t("edit-item")}
                      </Button>

                      {(item.samplePrice || item.printedPrice) && (
                        <Button
                          style={{
                            backgroundColor: "#fff",
                            color: "#484888",
                            margin: "-2rem 0rem",
                            fontSize: 15,
                            fontWeight: "500",
                          }}
                          onClick={() => {
                            setBuySampleModal(true);
                          }}
                        >
                          {t("order-sample")}
                        </Button>
                      )}

                      {!item.productId && (
                        <FooterValues>
                          {t("production-time")}:{" "}
                          {item.productionTime === 1 ? (
                            <>
                              {item.productionTime} {t("business-day-small")}
                            </>
                          ) : (
                            <>
                              {item.productionTime} {t("business-days-small")}
                            </>
                          )}
                        </FooterValues>
                      )}
                    </Titles>
                  </StyledColumn>
                </Row>
                <SuggestedItemsContainer>
                  <Title>{t("you-may-also-like")}</Title>
                  <SuggestRelative>
                    {suggestIndex + suggestGroupSize <
                      suggestedItems.length && (
                      <ChevronContainerSuggest onClick={handleNextSuggest}>
                        <ChevronRight />
                      </ChevronContainerSuggest>
                    )}

                    {suggestIndex > 0 && (
                      <ChevronContainerSuggest
                        onClick={handlePreviousSuggest}
                        $left
                      >
                        <ChevronLeft />
                      </ChevronContainerSuggest>
                    )}

                    <SuggestedRow>
                      {visibleSuggestItems?.map((suggestedItem, i) => {
                        return (
                          <SuggestItem
                            key={i}
                            onClick={() => {
                              window.scrollTo(0, 0);
                              if (
                                location.pathname === "/ops-portal/marketplace"
                              ) {
                                navigate(
                                  `/ops-portal/marketplace/item-detail/${suggestedItem.id}`,
                                );
                              } else {
                                if (loggedIn) {
                                  navigate(
                                    `/admin-portal/marketplace/item-detail/${suggestedItem.id}`,
                                  );
                                } else {
                                  navigate(`/marketplace/${suggestedItem.id}`);
                                }
                              }
                            }}
                          >
                            <SuggestItemPhoto
                              src={suggestedItem.marketplacePhotos[0].url}
                            />
                            <SuggestItemName>
                              {ar && suggestedItem?.nameAr
                                ? suggestedItem?.nameAr
                                : suggestedItem?.name}
                            </SuggestItemName>
                            <SuggestItemPrice>
                              {priceFormatter(suggestedItem.price, true, 15)}{" "}
                              {getCurrencySymbol(suggestedItem?.currency)}
                            </SuggestItemPrice>
                          </SuggestItem>
                        );
                      })}
                    </SuggestedRow>
                  </SuggestRelative>
                </SuggestedItemsContainer>
              </>
            ) : (
              <ErrorDiv>
                <Title>{t("item-does-not-exist")}</Title>
                <Success src={FailedImg} alt="success-img" />
                <SubTitle
                  onClick={() =>
                    !loggedIn
                      ? navigate("/marketplace")
                      : navigate("/admin-portal/marketplace")
                  }
                >
                  {t("go-back-marketplace")}{" "}
                </SubTitle>
              </ErrorDiv>
            )
          ) : (
            <LoaderDiv>
              <MiniLoader />
            </LoaderDiv>
          )}
        </Content>

        <Footer ar={ar} />
      </MainContainer>

      <KeepInMindModal
        open={showKeepInMindModal}
        close={() => setShowKeepInMindModal(false)}
      />

      <GalleryModal
        open={openGallery}
        onClose={() => {
          setOpenGallery(false);
        }}
        width={"50%"}
        height={"50%"}
        images={photos}
        index={currentIndex}
        url
      />
      <LoginModal open={loginModal} close={() => setLoginModal(false)} title />
      <QuantityModal
        open={quantityModal}
        close={() => setQuantityModal(false)}
        availableQuantity={item.availableQuantity}
        onYes={onQuantityModalYes}
        zIndex={1000001}
        modalSubtitle={modalSubtitle}
      />
      <PriceBreakModal
        close={() => setPriceBreaksModal(false)}
        open={priceBreaksModal}
        item={item}
        data={item.priceBreaks}
      />
      <CartModal
        close={() => setCartModal(false)}
        open={cartModal}
        loadingItemId={loadingItemId}
      />
      <InstantQuoteModal
        open={instantQuoteModal}
        close={() => setInstantQuoteModal(false)}
        minQuantity={item.minQuantity ?? 1}
        itemId={itemId}
        subcategoryIds={[activeColor, activeSize, activeCard].filter(
          (item) => Object.keys(item).length > 0,
        )}
      />
      <BuySampleModal
        open={buySampleModal}
        quantityBlank={quantityBlank}
        setQuantityBlank={setQuantityBlank}
        quantityBranded={quantityBranded}
        setQuantityBranded={setQuantityBranded}
        item={item}
        errorBranded={errorBranded}
        errorBlank={errorBlank}
        onBuyPrinted={() => {
          if (validate(false, true)) {
            if (quantityBranded <= 0) {
              setErrorBranded(true);
              return;
            } else {
              dispatch(
                addToCart({
                  id: item.id,
                  name: item.name,
                  photo: photos[0],
                  color: {
                    id: activeColor?.id,
                    name: activeColor?.name,
                  },
                  size: {
                    id: activeSize?.id,
                    name: activeSize?.name,
                  },
                  giftCard: {
                    id: activeCard?.id,
                    name: activeCard?.name,
                    price: activeCard?.price,
                  },
                  uploadLogoUrl: logoUrl,
                  priceBreaks: item.priceBreaks,
                  samplePrice: null,
                  printedPrice: priceFormatterNumber(
                    item.printedPrice,
                    true,
                    15,
                  ),
                  itemPrice: activeCard.price ? activeCard.price : item.price,
                  printedQuantity: quantityBranded,
                  sampleQuantity: null,
                  minQuantity: item.minQuantity,
                  quantity: +quantityValue,
                  productionTime: item.productionTime,
                  totalPrice: null,
                  buyBlank: false,
                  buyPrinted: true,
                  currency: item.currency,
                  favorite: item.favorite,
                  businessUserId: id,
                }),
              );
              toast.success(t("item-added-to-cart-successfully"));
              setQuantityBlank(0);
              setQuantityBranded(0);
              setBuySampleModal(false);
              setErrorBlank(false);
              setErrorBranded(false);
              setCartModal(true);
            }
          }
        }}
        onBuyBlank={() => {
          if (validate(true, false)) {
            if (quantityBlank <= 0) {
              setErrorBlank();
            } else {
              dispatch(
                addToCart({
                  id: item.id,
                  name: item.name,
                  photo: photos[0],
                  color: {
                    id: activeColor?.id,
                    name: activeColor?.name,
                  },
                  size: {
                    id: activeSize?.id,
                    name: activeSize?.name,
                  },
                  giftCard: {
                    id: activeCard?.id,
                    name: activeCard?.name,
                    price: activeCard?.price,
                  },
                  uploadLogoUrl: logoUrl,
                  priceBreaks: item.priceBreaks,
                  printedPrice: null,
                  sampleQuantity: quantityBlank,
                  samplePrice: priceFormatterNumber(item.samplePrice, true, 15),
                  printedQuantity: null,
                  itemPrice: item.price,
                  minQuantity: item.minQuantity,
                  quantity: +quantityValue,
                  productionTime: item.productionTime,
                  totalPrice: null,
                  buyBlank: true,
                  buyPrinted: false,
                  currency: item.currency,
                  favorite: item.favorite,
                  businessUserId: id,
                }),
              );
              toast.success(t("item-added-to-cart-successfully"));
              setBuySampleModal(false);
              setQuantityBlank(0);
              setQuantityBranded(0);
              setErrorBlank(false);
              setErrorBranded(false);
              setCartModal(true);
            }
          }
        }}
        close={() => setBuySampleModal(false)}
      />
    </>
  );
};

export default MarketplaceItemDetailPage;
